<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Consultation Sous categorie</h2>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label>Sous categorie choisis:</label>
    </div>
    <div class="col txt">
      <p> <span v-for="sc in this.listesSousCategorie" :key="sc">
        {{ sc }}
        <br/>
      </span></p>
    </div>
  </div>
  <ButtonBarSousCategorie :actionAccesDecision="actionAccesDecision"
                          @fermer="fermer" @modifier="modifier"/>
</template>

<script>
import axios from "axios";
import {mapGetters} from "vuex";
import ButtonBarSousCategorie from "../../../components/dossier/Consulter/ButtonBarSousCategorie";

export default {
  name: "ConsulterSousCategorie",
  components: {
    ButtonBarSousCategorie,
  },
  mounted() {
    this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter SousCategorie");
    this.getSousCategorie();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: "dossier/actionAccesDecision",
      dossier: 'dossier/dossier',
    })
  },
  data() {
    return {
      isDataLoading: false,
      listesSousCategorie: [],
    };
  },
  methods: {
    assignerSousCategorie(list) {
      list.forEach(sc => {
        this.listesSousCategorie.push(sc.sousCategorieAfficher)
      });
    },
    getSousCategorie() {
      this.$store
          .dispatch("sousCategorie/consulterSousCategorieAction", {
            cle: this.$route.params.cleDossier,
            site: this.$route.params.siteDossier
          })
          .then((res) => {
            this.assignerSousCategorie(res.data.entites);
            this.isDataLoading = false;
          });
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    modifier() {
      this.$router.push({
        name: "modifierSousCategorie",
        params: {
          cleDossier: this.$route.params.cleDossier,
          siteDossier: this.$route.params.siteDossier
        },
      });
    },
  },
}
</script>